import produce from 'immer';

import {
  FETCH_FAVORITE_DRAMAS_SUCCEEDED,
  ADD_FAVORITE_DRAMA_OPTIMISTIC,
  REMOVE_FAVORITE_DRAMA_OPTIMISTIC,
  LOGOUT,
} from '../../constants/actionTypes';

const initState = [];

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_FAVORITE_DRAMAS_SUCCEEDED: {
      return action.payload.result;
    }

    case ADD_FAVORITE_DRAMA_OPTIMISTIC: {
      const dramaId = action.payload;

      if (!draft.includes(dramaId)) {
        draft.unshift(dramaId);
      }

      return;
    }

    case REMOVE_FAVORITE_DRAMA_OPTIMISTIC: {
      const dramaId = action.payload;
      const index = draft.findIndex((id) => id === dramaId);

      if (index !== -1) {
        draft.splice(index, 1);
      }

      return;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
